import script from "./PaymentResult.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentResult.vue?vue&type=script&setup=true&lang=js"

import "./PaymentResult.vue?vue&type=style&index=0&id=366ec63e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-366ec63e"]])

export default __exports__